export const MAX_TRANSIENT_RETRIES = 5;
export const TRANSIENT_WINDOW_MS = 300000;

const TRANSIENT_STATUSES = [408, 429, 502, 503, 504];
const DELAYS_MS = [2000, 4000, 8000, 16000, 30000];
const MAX_DELAY_MS = 30000;
const JITTER_FLOOR = 0.8;
const JITTER_SPAN = 0.4;
const MS_PER_SECOND = 1000;
const DECIMAL_RADIX = 10;

export const isTransientFailure = (error) =>
    !error?.status || TRANSIENT_STATUSES.includes(error.status);

export const retryAfterSecondsOf = (error) => {
    const seconds = Number.parseInt(error?.response?.headers?.['retry-after'], DECIMAL_RADIX);
    return Number.isFinite(seconds) ? seconds : null;
};

export const nextDelayMs = (attempt, random = Math.random, retryAfterSeconds = null) => {
    const base = DELAYS_MS[Math.min(attempt, DELAYS_MS.length - 1)];
    const jittered = Math.round(base * (JITTER_FLOOR + JITTER_SPAN * random()));
    const requested = retryAfterSeconds ? retryAfterSeconds * MS_PER_SECOND : 0;
    return Math.min(Math.max(jittered, requested), MAX_DELAY_MS);
};

export const shouldRetryTransient = (error, now = Date.now()) => {
    const config = error?.config;
    if (!config || config.method !== 'get' || !isTransientFailure(error))
        return false;

    const startedAt = config._transientStartedAt ?? now;
    return (config._transientRetries || 0) < MAX_TRANSIENT_RETRIES && now - startedAt < TRANSIENT_WINDOW_MS;
};
